import { FETCH_BLOCKS, FETCH_BLOCK_INFO, RESET_BLOCKS } from '../actionTypes';

const initialState = {
  data: {},
  isLoadMore: false,
  info: {}
};

export default function(state = initialState, action=null){
  switch (action.type) {
    case FETCH_BLOCKS:
      let isLoadMore = true;
      if (Object.keys(action.payload).length === 0) {
        isLoadMore = false;
      }
      return {
        ...state,
        data: {...state.data, ...action.payload},
        isLoadMore: isLoadMore
      }
    case FETCH_BLOCK_INFO:
      return {...state, info: action.payload};
    case RESET_BLOCKS:
        return initialState;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/blocks.js